// import React from 'react'
// import { BUBBLES } from './Data'
// import { useNavigate } from 'react-router-dom'
// import { Button } from 'antd'

// const TermsCondition = () => {
//   const navigate = useNavigate()
//   const handleCancel = () => {
//     navigate('/')
//   }

//   return (
//     <div style={styles.container} className="p-2 p-md-0">
//       <div className="terms-wrapper">
//         {BUBBLES.map((b, i) => (
//           <div
//             key={i}
//             className="hero-bubble"
//             style={{
//               width: b.w,
//               height: b.w,
//               left: b.l,
//               top: b.t,
//               animationDelay: b.d,
//               maxWidth: '50px', // optional limit for small screens
//               maxHeight: '50px',
//             }}
//           />
//         ))}

//         <div className="row">
//           <div className="terms-page">
//             <h1 className="title">THE ROTARY SILVER JUBILEE TRUST, SWIMMING POOL, SANGLI.</h1>
//             <p className="subtitle">
//               {/* (दि रोटरी सिल्वर जुबिली ट्रस्ट, सांगली यांचा उपक्रम) */}
//             </p>

//             <hr />

//             <h2 className="warning">
//               जलतरण तलावात प्रवेश करण्यापूर्वी खालील ‘वापर नियमावली’ वाचणे
//               आवश्यक आहे
//             </h2>

//             <ol className="terms-list">
//               <li>
//                 या नियमावलीतील ‘तलाव’ या शब्दाचा अर्थ लहान व मोठा पोहण्याचा तलाव
//                 तसेच संपूर्ण इमारत व परिसर असा आहे.
//               </li>

//               <li>
//                 जलतरण केंद्रात प्रवेश करण्यासाठी वैध प्रवेशिका / पास / तिकीट
//                 असणे अनिवार्य आहे.
//               </li>

//               <li>
//                 सर्व जलतरणार्थींनी नियमित पोहण्याचा पोशाख (Swimming Costume) व
//                 स्विमिंग कॅप वापरणे आवश्यक आहे.
//                 <ul>
//                   <li>पुरुष व मुलांसाठी – पोहण्याची चड्डी व कॅप</li>
//                   <li>स्त्रिया व मुलींसाठी – स्विमिंग ड्रेस व कॅप</li>
//                 </ul>
//               </li>

//               <li>तलावात उतरण्यापूर्वी शॉवर घेणे अनिवार्य आहे.</li>

//               <li>
//                 शिकाऊ पोहणारे (Beginners) यांनी प्रशिक्षकांच्या देखरेखीखालीच
//                 तलावात उतरावे.
//               </li>

//               <li>
//                 ज्यांना स्वतंत्रपणे पोहता येत नाही त्यांनी प्रशिक्षकांच्या सर्व
//                 सूचना काटेकोरपणे पाळाव्यात.
//               </li>

//               <li>9 वर्षांखालील मुलांना मोठ्या तलावात उतरण्यास मनाई आहे.</li>

//               <li>
//                 तलावाच्या खोल पाण्यात (५ फूटपेक्षा पुढे) जाणे हे पूर्णपणे
//                 संबंधित व्यक्तीच्या स्वतःच्या जबाबदारीवर असेल.
//                 कोणतीही दुर्घटना झाल्यास ट्रस्ट किवा व्यवस्थापन जबाबदार राहणार नाही.

//               </li>

//               <li>
//                 ६५ वर्षांवरील व्यक्तींनी किंवा डॉक्टरांच्या सल्ल्याने पाण्यातील व्यायाम करणाऱ्यांनी स्वतः च्या जवाबदारीवर तलावात उतरावे
//               </li>

//               <li>
//                 तलावामध्ये चेंडू, खेळ, धक्का-बुक्की, धावाधाव किंवा कोणतेही गैरवर्तन
//                 करण्यास सक्त मनाई आहे.
//               </li>

//               <li>
//                 लाईफ मेंबर व त्यांच्यासोबत आलेल्या व्यक्तींनीही या नियमांचे पालन
//                 करणे बंधनकारक आहे.
//               </li>

//               <li>
//                 आवश्यक देखभाल, स्वच्छता किंवा इतर अपरिहार्य कारणांमुळे तलाव तात्पुरता बंद
//                 ठेवण्याचा अधिकार व्यवस्थापनाकडे राहील.
//               </li>

//               <li>
//                 दिलेल्या वेळेचा कालावधी संपल्यानंतर सर्वांनी तत्काळ तलावातून बाहेर येणे
//                 आवश्यक आहे.
//               </li>

//               <li>
//                 कोणालाही प्रवेश देणे अथवा न देणे हा अंतिम अधिकार ट्रस्टचे व्यवस्थापन व ट्रस्टी
//                 यांच्याकडे राहील.
//               </li>

//               <li>आपली मौल्यवान वस्तू स्वतःच्या जबाबदारीवर ठेवाव्यात. हरविल्यास व्यवस्थापन जवाबदार राहणार नाही.</li>

//               <li>
//                 तलाव परिसरात कोणतेही प्राणी, काच वस्तू किंवा हानिकारक द्रव्य
//                 आणण्यास मनाई आहे.
//               </li>

//               <li>
//                 वरील नियमांचे उल्लंघन करणाऱ्या व्यक्तीस तलाव परिसरातून बाहेर काढण्याचा अधिकार
//                 व्यवस्थापनाकडे राहील.
//               </li>

//               <li>
//                 जलतरण केंद्राची वेळ सकाळी ६.०० ते संध्याकाळी ७.०० अशी राहील.
//               </li>

//               <li className="highlight">
//                 प्रत्येक सोमवारी जलतरण केंद्र बंद राहील.
//               </li>

//               <li>
//                  आवश्यकतेनुसार या नियमांमध्ये बदल करण्याचा अधिकार ट्रस्ट व्यवस्थापनाकडे राहील.
//               </li>

//               <li className="danger">
//                 मद्य किंवा इतर अमली पदार्थांचे सेवन करून येणाऱ्या व्यक्तींना प्रवेश दिला जाणार नाही. नशेच्या अमलाखालील व्यक्ती पोहताना आढळल्यास त्याच्यावर फौजदारी कारवाई केली जाईन.
//                 </li>

//               <li>
//                 केंद्रातील कर्मचारी / प्रशिक्षक यांच्याशी वादविवाद करणे किंवा कामकाजात अडथळा आणणे आदळल्यास संबंधित व्यक्तीवर आवश्यक ती कारवाई केली जाईल.
//               </li>
//             </ol>

//             <div className="text-end pt-2">
//               <Button
//                 size="large"
//                 className="bg-dark text-white"
//                 onClick={handleCancel}
//               >
//                 Cancel
//               </Button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default TermsCondition

// const styles = {
//   container: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     background: 'linear-gradient(135deg,#0ea5e9,#2563eb)',
//     overflow: 'hidden', // hides any bubbles going outside
//     padding: '20px', // add some padding for small screens
//   },
// }

import React, { useEffect, useState } from 'react'
import { BUBBLES } from './Data'
import { useNavigate } from 'react-router-dom'
import { Button } from 'antd'
import axios from 'axios'
import { GetTermsConditionData } from '../API\'s/AdminApi'

const TermsCondition = () => {
  const navigate = useNavigate()

  const [terms, setTerms] = useState([])

  const handleCancel = () => {
    navigate('/')
  }

  // Fetch API
  useEffect(() => {
    getTerms()
  }, [])

  const getTerms = async () => {
    try {
      const response = await axios.get(
        GetTermsConditionData
      )

      const formattedData = Array.isArray(response.data) ? response.data : []
      setTerms(formattedData)
    } catch (error) {
      console.log('Error fetching terms:', error)
    }
  }

  return (
    <div style={styles.container} className="p-2 p-md-0">
      <div className="terms-wrapper">
        {BUBBLES.map((b, i) => (
          <div
            key={i}
            className="hero-bubble"
            style={{
              width: b.w,
              height: b.w,
              left: b.l,
              top: b.t,
              animationDelay: b.d,
              maxWidth: '50px',
              maxHeight: '50px',
            }}
          />
        ))}

        <div className="row">
          <div className="terms-page">
            <h1 className="title">
              THE ROTARY SILVER JUBILEE TRUST, SWIMMING POOL, SANGLI.
            </h1>

            <hr />

            <h2 className="warning">
              जलतरण तलावात प्रवेश करण्यापूर्वी खालील ‘वापर नियमावली’ वाचणे
              आवश्यक आहे
            </h2>

            {/* Dynamic Terms */}
            <ol className="terms-list">
              {terms?.map((item, index) => (
                <li key={item.id || index}>
                  {item.termsCondition}
                </li>
              ))}
            </ol>

            <div className="text-end pt-2">
              <Button
                size="large"
                className="bg-dark text-white"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsCondition

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg,#0ea5e9,#2563eb)',
    overflow: 'hidden',
    padding: '20px',
  },
}